<template>
  <div>
    <vs-card>
      <b-row class="justify-content-md-start">
        <b-col cols="3">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="arananDeger"
              id="smallInput"
              placeholder="Ara.."
              @keyup.enter="getStokList"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important;">
          <b-button
            style="background-color: #7367F0; border-color:white;"
            size="sm"
            v-on:click="getStokList()"
            ><Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"/></b-button
        ></b-col>
        <b-col cols="12" md="auto">
          <b-form-group label-for="item-name">
            <v-select
              v-model="selectedFirm"
              :options="firmaOptions"
              label="name"
              autocomplete
              @input="selectAll"
              size="sm"
              style="width: 200px"
            >
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto">
          <b-form-group label-for="item-name">
            <b-button
              size="sm"
              style="background-color:#28C76F; border-color:#28C76F;"
              v-on:click="kampanyaOlustur(0)"
              ><Icon
                style="margin-right: 5px"
                icon="mdi:source-pull"
                width="20"
                height="20"
              />Kampanya Oluştur</b-button
            >
          </b-form-group>
        </b-col>
      </b-row>
      <ag-grid-vue
        style="width: 100%; height: 550px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowdata"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :pagination="true"
        @grid-ready="onGridReady"
        :rowSelection="rowSelection"
        :groupSelectsChildren="true"
        :animateRows="true"
        :groupDisplayType="groupDisplayType"
        :rowClassRules="rowClassRules"
      >
      </ag-grid-vue>

    </vs-card>
    <b-modal
      ref="modal-stoklistdetay"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Stok Detay"
      size="xl"
      hide-footer
    >
      <vs-card>
        <b-row>
          <b-col cols="6">
            <b-row style="margin-bottom: 50px">
              <b-col cols="4" style="padding-right: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 50px"
                    variant="warning"
                  >
                    <span style="font-size: 13px">Stok Adı</span>
                  </b-list-group-item>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px"> Stok Kodu </span>
                  </b-list-group-item>

                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px">Barkod</span>
                  </b-list-group-item>
                  <!--
  
                    
                    <b-list-group-item
                      class="d-flex"
                      style="height: 30px;"
                      variant="warning"
                    >
                      <span style="font-size: 13px"> Ürün Kategorisi</span>
                    </b-list-group-item>
                    <b-list-group-item
                      class="d-flex"
                      style="height: 30px;"
                      variant="warning"
                    >
                      <span style="font-size: 13px"> Renk</span>
                    </b-list-group-item>-->
                </b-list-group>
              </b-col>
              <b-col cols="8" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 50px"
                    variant="warning"
                  >
                    <span style="font-size: 13px">{{ stokAdi }}</span>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex" style="height: 30px;">
                    <span style="font-size: 13px">{{ stokKodu }}</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 30px;">
                    <span style="font-size: 13px">{{ Barkod }}</span>
                  </b-list-group-item>
                  <!--
                    <b-list-group-item class="d-flex" style="height: 30px;">
                      <span style="font-size: 13px">{{ kategori1 }}</span>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex" style="height: 30px;">
                      <span style="font-size: 13px">{{ renk }}</span>
                    </b-list-group-item>-->
                </b-list-group>
              </b-col>
            </b-row></b-col
          >
          <b-col>
            <b-row style="margin-bottom: 50px">
              <b-col cols="4" style="padding-right: 0">
                <b-list-group>
                  <!--
                    <b-list-group-item
                      class="d-flex"
                      style="height: 30px;"
                      variant="warning"
                    >
                      <span style="font-size: 13px"
                        ><b-row>
                          <b-col>
                            Beden
                          </b-col>
                        </b-row></span
                      >
                    </b-list-group-item>-->
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px">
                      Diğer Özellikler
                    </span>
                  </b-list-group-item>

                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px"> Ürün Açıklaması</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="8" style="padding-left: 0">
                <b-list-group>
                  <b-list-group-item
                    class="d-flex"
                    style="height: 30px;"
                    variant="warning"
                  >
                    <span style="font-size: 13px">{{ beden }}</span>
                  </b-list-group-item>

                  <b-list-group-item class="d-flex" style="height: 30px;">
                    <span style="font-size: 13px">{{ gonderilenDetay }}</span>
                  </b-list-group-item>
                  <b-list-group-item class="d-flex" style="height: 50px;">
                    <span style="font-size: 13px"></span>
                  </b-list-group-item>
                </b-list-group>
              </b-col> </b-row
          ></b-col>
        </b-row>
      </vs-card>
      <vs-divider></vs-divider>
      <vs-card
        v-if="stokDetayRowData"
        style="padding-right: 20px; margin-bottom: 5px !important;"
      >
        <b-row
          style="    margin-bottom: 0px !important;padding-bottom: 0px !important;"
        >
          <b-col
            cols="1"
            style=" text-decoration: underline;
      color: #EA5455;"
            >Firma</b-col
          >
          <b-col style=" text-decoration: underline;color: #EA5455;" cols="2"
            >Stok Adı</b-col
          >
          <b-col
            cols="3"
            style=" text-decoration: underline;
      color: #EA5455;"
          >
            <b-row>
              <b-col>Stok Kodu</b-col>
              <b-col>Barkod</b-col>
            </b-row>
          </b-col>

          <b-col
            style=" text-decoration: underline;
      color: #EA5455;"
            cols="3"
          >
            <b-row>
              <b-col>Adet</b-col>
              <b-col>Fiyat</b-col>
              <b-col>Döviz</b-col>
              <b-col>Kdv</b-col>
            </b-row>
          </b-col>
          <b-col
            cols="2"
            style=" text-decoration: underline;
      color: #EA5455;"
          >
            <b-row>
              <b-col>Kampanyalı Adet</b-col>
              <b-col>Kampanyalı Fiyat</b-col>
            </b-row>
          </b-col>
          <b-col
            cols="1"
            style=" text-decoration: underline;
      color: #EA5455;"
          >
            İşlemler
          </b-col>
        </b-row>
      </vs-card>

      <div :class="scrollview">
        <div v-for="(item, index) in stokDetayRowData" :key="index">
          <vs-card
            style="margin-bottom: 5px !important;"
            :style="
              item.oncelik == true
                ? 'margin-bottom: 5px !important; background-color: #ddf8e9;'
                : ''
            "
          >
            <b-row align-v="center">
              <b-col cols="1"
                ><div style="overflow-wrap: anywhere;">
                  {{ item.firma }}
                </div>
              </b-col>
              <b-col cols="2">
                <div style="overflow-wrap: anywhere;">
                  {{ item.stokName }}
                </div>
              </b-col>
              <b-col cols="3">
                <b-row>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere;">
                      {{ item.stokKodu }}
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere;">
                      {{ item.barkod }}
                    </div></b-col
                  >
                </b-row>
              </b-col>

              <b-col cols="3">
                <b-row>
                  <b-col>{{ item.adet }}</b-col>
                  <b-col>{{
                    currencyFormatter(
                      item.fiyat,
                      item.doviz == "USD"
                        ? "$"
                        : item.doviz == "EUR"
                        ? "€"
                        : "₺"
                    )
                  }}</b-col>
                  <b-col>{{ item.doviz }}</b-col>
                  <b-col>{{ item.kdv }}</b-col>
                </b-row>
              </b-col>
              <b-col cols="2">
                <b-row>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere;">
                      {{ item.kampanyaAdet }}
                    </div>
                  </b-col>
                  <b-col cols="6">
                    <div style="overflow-wrap: anywhere;">
                      {{
                        currencyFormatter(
                          item.kampanyaFiyat,
                          item.doviz == "USD"
                            ? "$"
                            : item.doviz == "EUR"
                            ? "€"
                            : "₺"
                        )
                      }}
                    </div></b-col
                  >
                </b-row>
              </b-col>
              <b-col cols="1">
                <b-row>
                  <b-col cols="6" v-if="item.oncelik == true"
                    ><b-button
                      size="sm"
                      style="background-color: #7367F0;     border-color: #7367F0;"
                      v-on:click="oncelikliOlarakIsaretle(item)"
                      ><Icon
                        icon="mdi:priority-high"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="
                          'Öncelikli olarak işaretle'
                        "/></b-button
                  ></b-col>
                  <b-col cols="6" v-else
                    ><b-button
                      size="sm"
                      variant="outline-light"
                      v-on:click="oncelikliOlarakIsaretle(item)"
                      ><Icon
                        icon="mdi:priority-high"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="'Öncelikli olarak işaretle'"
                        color="#7367F0"/></b-button
                  ></b-col>
                  <b-col
                    cols="6"
                    v-if="item.oncelik == true"
                    style="    padding: 0px !important;"
                    ><b-button
                      size="sm"
                      v-on:click="kampanyaOlustur(item)"
                      style="background-color: #FF9F43;     border-color: #FF9F43;"
                      ><Icon
                        icon="mdi:discount"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="
                          'Kampanya oluştur'
                        "/></b-button
                  ></b-col>
                  <b-col cols="6" v-else style="    padding: 0px !important;"
                    ><b-button
                      size="sm"
                      variant="outline-light"
                      v-on:click="kampanyaOlustur(item)"
                      ><Icon
                        icon="mdi:discount"
                        width="20"
                        height="20"
                        v-b-tooltip.hover.bottom="'Kampanya oluştur'"
                        color="#FF9F43"/></b-button
                  ></b-col>
                </b-row>
              </b-col>
            </b-row>
          </vs-card>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="modal-kampanyaEkle"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      title="Kampanya Ekle"
      size="md"
      hide-footer
    >
      <div style="min-height: 350px">
        <vs-card>
          <div>
            <b-row>
              <b-col>
                <b-form-group label="Adet" label-for="item-name"
                  ><b-form-input
                    id="stok-no"
                    v-model="kampanyaAdet"/></b-form-group
              ></b-col>

              <b-col>
                <b-form-group label="Oran" label-for="item-name"
                  ><b-form-input
                    id="stok-no"
                    v-model="kampanyaOran"/></b-form-group
              ></b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Kampanya Başlangıç" label-for="item-name"
                  ><b-form-datepicker
                    id="kampanyaBaslangic"
                    v-model="kampanyaBaslangic"
                    size="md"
                    local="en"
                    class="mb-2"
                    today-variant="success"
                    placeholder="-"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric'
                    }"/></b-form-group
              ></b-col>
              <b-col>
                <b-form-group label="Kampanya Bitiş" label-for="item-name"
                  ><b-form-datepicker
                    id="kampanyaBitis"
                    v-model="kampanyaBitis"
                    size="md"
                    local="en"
                    class="mb-2"
                    today-variant="success"
                    placeholder="-"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric'
                    }"/></b-form-group
              ></b-col>
            </b-row>
          </div>

          <div slot="footer">
            <vs-row vs-justify="flex-end">
              <b-button
                style="background-color: #EA5455; border-color:#EA5455;"
                v-on:click="kampanyaKaydet('sil')"
                ><Icon
                  style="margin-right: 5px"
                  icon="ic:baseline-remove-circle"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Kampanyayı Sil'"
                />Sil</b-button
              >
              <b-button
                style="background-color: #28C76F; border-color:#28C76F;"
                v-on:click="kampanyaKaydet()"
                ><Icon
                  style="margin-right: 5px"
                  icon="mdi:content-save-check-outline"
                  width="20"
                  height="20"
                  v-b-tooltip.hover.bottom="'Kampanya oluştur'"
                />Kaydet</b-button
              >
            </vs-row>
          </div>
        </vs-card>
      </div>
    </b-modal>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import state from "../../store/state";
import Store from "../../store/store";
import PazaryeriGorunumCellRenderer from "./CellRenderers/PazaryeriGorunumCellRenderer.vue";
import TedarikciGorunumCellRenderer from "./CellRenderers/TedarikciGorunumCellRenderer.vue";
import DateGorunumCellRenderer from "./CellRenderers/DateGorunumCellRenderer.vue";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import CurrencyGorunumCellRenderer from "./CellRenderers/CurrencyGorunumCellRenderer.vue";
import StokListDetayButon from "../components/uzum-components/stoklistesi-components/StokListDetayButon.vue";
export default {
  data() {
    return {
      rowClassRules: null,
      groupDisplayType: null,
      firmaOptions: "",
      selectedFirm: "",
      sideBar: null,
      scrollview: "",
      kampanyaBaslangic: "",
      kampanyaBitis: "",
      kampanyaAdet: 0,
      kampanyaTutat: 0.0,
      kampanyaOran: 0,
      xmlDetayBarkod: [],
      pageLength: 50,
      KAYITSAYISI: 0,
      stokAdi: "",
      stokKodu: "",
      Barkod: "",
      kategori1: "",
      renk: "",
      beden: "",
      gonderilenDetay: "",
      stokDetayRowData: null,
      arananDeger: "",
      rowSelection: null,
      rowdata: null,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      localeText: null,
      columnDefs: null,
      kampanyaItem: []
    };
  },
  created() {
    this.getStokList();
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.rowSelection = "multiple";
    this.scrollview = "scroll-hand";
    this.sideBar = "filters";
    this.groupDisplayType = "groupRows";
    this.rowClassRules = {
      // apply green to 2008
      "green-row": function(params) {
        if (typeof params.data != "undefined")
          return params.data.oncelik === true;
      }
    };
  },
  components: {
    "v-select": vSelect,
    Icon,
    AgGridVue,
    CurrencyGorunumCellRenderer,
    TextGorunumCellRenderer,
    DateGorunumCellRenderer,
    PazaryeriGorunumCellRenderer,
    TedarikciGorunumCellRenderer,
    StokListDetayButon
  },
  methods: {
    selectAll() {
      this.gridApi.forEachNode((rowNode, index) => {
        if (typeof rowNode.data != "undefined")
          rowNode.setSelected(rowNode.data.firma == this.selectedFirm);
      });
    },
    handscroll(el) {},
    currencyFormatter(currency, sign) {
      if (typeof currency == "undefined" || currency == null) return 0;
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    kampanyaKaydet(sil) {
      var vs = this.$vs;
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const selectedData = this.gridApi.getSelectedRows();
      if (vm.kampanyaOran == "" || vm.kampanyaOran == 0) {
        vs.notify({
          title: "Kampanya Ekleme",
          text: "Kampanya Oran Bilgisi Girilmelidir",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center"
        });
      } else {
        selectedData.forEach((val, index) => {
          const args = {
            token: Store.state.tokenId,
            pazaryeriKod: val.pazaryeriKod,
            stokId: val.stokId,
            kampanyaBaslangic: vm.kampanyaBaslangic,
            kampanyaBitis: vm.kampanyaBitis,
            kampanyaAdet: vm.kampanyaAdet,
            kampanyaFiyat:
              val.fiyat -
              (vm.kampanyaOran.includes(".") ||
              vm.kampanyaOran.includes(",") == true
                ? val.fiyat * vm.kampanyaOran.replace(",", ".")
                : (vm.kampanyaOran / 100) * val.fiyat),
            kampanyaOran: vm.kampanyaOran.replace(",", ".")
          };

          soap.createClient(url, function(err, client) {
            client.oncelikliStokGuncelle(args, function(err, result) {
              if (result.oncelikliStokGuncelleResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              vm.veriler = JSON.parse(result.oncelikliStokGuncelleResult);
              vm.kampanyaBaslangic = "";
              vm.kampanyaBitis = "";
              vm.kampanyaAdet = 0;
              vm.kampanyaTutat = 0.0;
              vm.kampanyaOran = 0;
              vm.getStokList();
              vm.$refs["modal-kampanyaEkle"].hide();
            });
          });
        });
      }
    },
    kampanyaOlustur(item) {
      this.$refs["modal-kampanyaEkle"].show();
      this.kampanyaItem = item;
      /*    if (this.kampanyaItem.kampanyaBaslangic != "1900-01-01T00:00:00")
          this.kampanyaBaslangic = this.kampanyaItem.kampanyaBaslangic;
        if (this.kampanyaItem.kampanyaBitis != "1900-01-01T00:00:00")
          this.kampanyaBitis = this.kampanyaItem.kampanyaBitis;
        this.kampanyaAdet = this.kampanyaItem.kampanyaAdet;
        this.kampanyaTutat = this.kampanyaItem.kampanyaFiyat;*/
    },
    oncelikliOlarakIsaretle(item) {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeriKod: vm.xmlDetayBarkod.Barkod,
        stokId: item.stokId
      };
      soap.createClient(url, function(err, client) {
        client.oncelikliStokGuncelle(args, function(err, result) {
          if (result.oncelikliStokGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.oncelikliStokGuncelleResult);
          vm.getxmlStokList(vm.xmlDetayBarkod);
        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getStokList() {
      var vm = this;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        barcode: vm.arananDeger
      };
      soap.createClient(url, function(err, client) {
        client.xmlStokListesiForDiscount(args, function(err, result) {
          if (result.xmlStokListesiForDiscountResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.xmlStokListesiForDiscountResult);
          vm.rowdata = vm.veriler.jsonData;
          const firmalar = [...new Set(vm.rowdata.map(x => x.firma))];
          vm.firmaOptions = firmalar;
        });
      });
    },
    getxmlStokList(stokDetayVal) {
      this.$refs["modal-stoklistdetay"].show();
      var vm = this;
      vm.xmlDetayBarkod = stokDetayVal;
      vm.veriler = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        barcode: stokDetayVal.Barkod
      };
      soap.createClient(url, function(err, client) {
        client.xmlStokListesi(args, function(err, result) {
          if (result.xmlStokListesiResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.xmlStokListesiResult);
          vm.stokDetayRowData = vm.veriler.jsonData;
          vm.stokAdi = stokDetayVal.StokAdi;
          vm.stokKodu = stokDetayVal.stokKodu;
          vm.Barkod = stokDetayVal.Barkod;
          vm.kategori1 = stokDetayVal.kategori1;
          vm.renk = stokDetayVal.renk;
          vm.beden = stokDetayVal.beden;
          vm.gonderilenDetay = stokDetayVal.gonderilenDetay;
        });
      });
    }
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("getxmlStokList", stokDetayVal => {
      this.getxmlStokList(stokDetayVal);
    });
  },
  beforeDestroy() {
    this.$root.$off("getxmlStokList");
  },
  beforeMount() {
    this.columnDefs = [
      /*   {
          headerName: "Firma",
          field: "firma",
          sortable: true,
          filter: "agSetColumnFilter",
          filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
        },*/
      {
        headerName: "Firma",
        field: "pazaryeriKod",
        sortable: true,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        rowGroup: true,
        hide: true
      },
      {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        headerName: "Firma",
        field: "firma",
        sortable: true,
        width: 130,
        filter: "agSetColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Barkod",
        field: "barkod",
        sortable: true,
        filter: "agSetColumnFilter",
        width: 130,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Pazaryeri Stok",
        sortable: true,
        filter: "agSetColumnFilter",
        field: "stokAdi",
        cellRenderer: "PazaryeriGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 250,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },

      {
        headerName: "Tedarikçi Stok",
        field: "stokName",
        sortable: true,
        filter: "agTextColumnFilter",
        cellRenderer: "TedarikciGorunumCellRenderer",
        wrapText: true,
        autoHeight: true,
        width: 250,
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },

      {
        headerName: "Fiyat",
        field: "fiyat",
        sortable: true,
        filter: "agTextColumnFilter",
        width: 100,
        cellRenderer: "CurrencyGorunumCellRenderer",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      },
      {
        headerName: "Kampanya",
        marryChildren: true,
        children: [
          {
            headerName: "Adet",
            field: "kampanyaAdet",
            sortable: true,
            width: 100,
            filter: "agTextColumnFilter",
            filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
          },
          {
            headerName: "Başlangıç",
            field: "kampanyaBaslangic",
            sortable: true,
            width: 100,

            filter: "agTextColumnFilter",
            cellRenderer: "DateGorunumCellRenderer",
            filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
          },
          {
            headerName: "Bitiş",
            field: "kampanyaBitis",
            sortable: true,
            width: 100,

            filter: "agTextColumnFilter",
            cellRenderer: "DateGorunumCellRenderer",
            filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
          },
          {
            headerName: "Fiyat",
            field: "kampanyaFiyat",
            sortable: true,
            width: 100,
            filter: "agTextColumnFilter",
            cellRenderer: "CurrencyGorunumCellRenderer",

            filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
          }
        ]
      },
/*
      {
        headerName: "Öncelik",
        field: "oncelik",
        sortable: true,
        filter: "agTextColumnFilter",
        width: 100,

        filterParams: { buttons: ["apply", "reset"], closeOnApply: true }
      }*/
    ];
  }
};
</script>
<style lang="scss">
.green-row {
  background-color: #9debc0 !important;
}
.scroll-hand {
  max-height: 260px;
  overflow-y: auto;
  overflow-x: hidden;
}
.vs-card--content {
  margin-bottom: 5px !important;
}
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

[dir] .modal-title {
  margin-bottom: 0;
  color: #7367f0 !important;
}

[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}

[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}

[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}

[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}

[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.my-fancy-class {
  background-color: #7367f0;
}
#main {
  width: 200px;
  height: 200px;
  border: 1px solid #c3c3c3;
  display: flex;
  flex-wrap: wrap;
}

#main div {
  width: 50px;
  height: 50px;
}
</style>
